import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import { Container, Image, Table  } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import Category from './Category';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import * as RIcon from "react-icons/fa"
import { Link } from 'react-router-dom';

const ItemStock = () => {
    const {t,i18n} = useTranslation()
    return(
    <div className="wrapper">
        <header className="App-header"></header>
        <Header />
        <Category />
        <Container className='w-100'>
            <h4>商品仕入</h4>
            <Table>
                <th>商品ID</th><th>入庫数</th><th></th>
            </Table>
        </Container>
        <Footer />
    </div>
    )
}

export default ItemStock;
